<template>
    <div :class="$style.root">
        <div class="bottom">Copyright © 2018南京超然科技有限公司 苏ICP备05079548号-1</div>
    </div>
</template>

<script>
    export default {
        name: 'Footer',

        methods: {},
    };
</script>

<style lang="less" module>
    @import "../styles/variables";

    .root {
        :global {
            width: 100%;
            height: 120px;
            line-height: 100px;
            color: #fff;
            color: #fff;
            text-align: center;
            background: #435573;
            border-top: 20px solid #b0bbd2;
            bottom: 0;
        }
    }
</style>
